import { path, isEmpty } from 'ramda'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router'
import CreateContract from '@/features/Contract/CreateContract'
import useContractAddendumTemplates from '@/hooks/use-contract-addendum-templates'
import { select } from '@/store'
import { isNotEmpty } from '@/utils'

const ListingCreateContract = ({ noTitle }) => {
  const history = useHistory()
  const { listingId, contractId } = useParams()
  const dispatch = useDispatch()
  const listingContract = useSelector(path(['listing', listingId, 'contract']))
  const contract = useSelector(state =>
    select.contract.contractDetail(state, {
      contractId,
      listingId
    })
  )
  useContractAddendumTemplates()

  useEffect(() => {
    dispatch.listing.load(listingId)
    if (!contractId) {
      dispatch.listing.getContract(listingId)
    }
  }, [contractId, dispatch.listing, listingId])

  useEffect(() => {
    if (!contractId && listingContract?.listing_contract_id) {
      history.replace(
        `/listing/${listingId}/contract/create/${listingContract.listing_contract_id || ''}`
      )
    }
  }, [contractId, history, listingContract, listingId])

  useEffect(() => {
    if (contractId) {
      dispatch.contract.load(contractId)
    }
  }, [contractId, dispatch.contract])
  const preventRender = () => {
    if (contractId) return isEmpty(contract)
    return !listingContract || (isNotEmpty(listingContract) && isEmpty(contract))
  }

  if (preventRender()) return null
  return (
    <CreateContract
      contractId={contractId}
      listingId={listingId}
      contract={contract}
      noTitle={noTitle}
    />
  )
}

export default ListingCreateContract
